module.exports = __webpack_public_path__ + "media/FIVEx_tutorial_6.090130ef.mp4";